import React, { useEffect } from 'react'

import { CreateDetergentComponentForm, CreateDetergentPageHeader } from '@/components/pages/Detergents/Create'
import { useTanks } from '@/pages/Tank/Tank.hooks'

import { useCreateDetergent } from './Create.hooks'

const CreateDetergent = () => {
  const { createDetergent, loading } = useCreateDetergent()
  const { getAllTanks, tanks } = useTanks()

  useEffect(() => {
    getAllTanks()
  }, [getAllTanks])

  return (
    <>
      <CreateDetergentPageHeader />
      <CreateDetergentComponentForm {...{ loading, tanks }} onSubmit={createDetergent} />
    </>
  )
}

CreateDetergent.displayName = 'CreateDetergent'
export default CreateDetergent
